import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { UserLogModel } from './userlogs';
import { UserLog } from './userlog';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class UserLogService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    dUserLog(data): Promise<UserLog> {
        return this.httpmanagerService.HttpPost('suserlog', JSON.stringify(data), "").then(data => {
            return data
        })
    }
    gUserLog(): Promise<UserLogModel[]> {
        return this.httpmanagerService.HttpGet('suserlog', "").then(data => {
            return data.data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/userlog/userlog.service.ts